import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';

import HeaderFixedButtons from './HeaderFixedButtons';
import styles from './HeaderFixedMobile.module.css';

const HeaderFixedMobile = (props) => {
    const [openedIndex, setOpenedIndex] = useState(null);

    const toggleItem = (e, index) => {
        e.preventDefault();
        if (index === openedIndex) {
            setOpenedIndex(null);
        } else {
            setOpenedIndex(index);
        }
    };

    const location = useLocation();

    const linkIsSelected = (link) =>
        link.nav_links.some((nl) => nl.url === location.pathname) ||
        link.submenu?.some((submenu) => submenu.nav_links.some((nl) => nl.url === location.pathname));
    const navLinkIsSelected = (navlink) => navlink.url === location.pathname;

    const renderMenuLinks = (link) => {
        return (
            <PromoText tag="listItem" color={props.promoDarkPage ? 'white' : 'baseColor'} key={link.id}>
                <a
                    className={`${styles.subMenuLink} ${props.promoDarkPage ? styles.subMenuLinkDark : null} ${navLinkIsSelected(link) ? styles.subMenuLinkSelected : ''}`}
                    href={link.url}
                    title={link.title}
                    target={link.isBlank ? '_blank' : null}
                    tabIndex={'0'}
                >
                    {link?.icon?.url && <img className={styles.submenuIcon} src={link.icon?.url} alt={link.title} width={'24'} height={'24'} />}
                    {link.title}
                </a>
            </PromoText>
        );
    };

    if (props.libre) {
        return false;
    } else {
        return (
            <div className={`${styles.overlayNavigation} ${props.promoDarkPage ? styles.overlayNavigationDark : null}`}>
                <div className={styles.navigationWrapper}>
                    <div className={styles.navigationContainer}>
                        {props.data &&
                            props.data
                                .filter((link) => !link?.authorised_user)
                                .map((link, index) => {
                                    return (
                                        <div key={index}>
                                            <a
                                                className={`${styles.tabNameMobile} ${props.promoDarkPage ? styles.tabNameMobileDark : null} ${linkIsSelected(link) ? styles.tabNameMobileSelected : ''}`}
                                                onClick={(e) => toggleItem(e, index)}
                                                onKeyPress={(e) => toggleItem(e, index)}
                                                tabIndex={'0'}
                                            >
                                                <PromoText variant="subheader" color={props.promoDarkPage ? 'white' : 'baseColor'}>
                                                    {link.title}
                                                </PromoText>
                                                <span className={`${styles.tabIcon} ${openedIndex === index ? styles.tabIconOpened : ''}`}>
                                                    <PromoIcon name="chevron-down" color={props.promoDarkPage ? 'white' : 'baseColor'} size="24px" />
                                                </span>
                                            </a>
                                            {openedIndex === index && (
                                                <>
                                                    {link.submenu && link.submenu.length > 0 ? (
                                                        <ul>
                                                            {link.submenu.map((submenuItem, index) => (
                                                                <li key={index}>
                                                                    {submenuItem.submenu_title && (
                                                                        <span className={styles.submenuTitle}>{submenuItem.submenu_title}</span>
                                                                    )}
                                                                    <ul>
                                                                        {submenuItem.nav_links
                                                                            .filter((item) => item !== null)
                                                                            .map((navlink) => renderMenuLinks(navlink))}
                                                                    </ul>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <ul>{link.nav_links.filter((item) => item !== null).map((navlink) => renderMenuLinks(navlink))}</ul>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                    </div>
                </div>
                {props.authData && (
                    <div className={styles.fixedPanel}>
                        <div className={styles.buttonsWrapper}>
                            <HeaderFixedButtons
                                isLanding={props.isLanding}
                                pageName={props.pageName}
                                data={props.authData}
                                isMobileMenu
                                fixedHeader={props.isFixed}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
};

export default HeaderFixedMobile;
